export default __webpack_public_path__ + "static/media/grilLaptop.b474eb56.jpg";